/**
 * Zustand Global Store - ersetzt schrittweise CustomEvents
 * Aktiv NUR wenn "experimentelles Caching" in Settings aktiviert ist.
 * Beide Pfade (CustomEvents + Zustand) koexistieren.
 */
import { create } from 'zustand';

const useDashboardStore = create((set, get) => ({
  // Cache-Invalidierung Signale
  cacheInvalidations: {},  // instanceId → timestamp
  invalidateCache: (instanceId) => set(state => ({
    cacheInvalidations: { ...state.cacheInvalidations, [instanceId]: Date.now() }
  })),

  // Globaler Refresh-Trigger (ersetzt CustomEvent 'refresh-data')
  refreshCounter: 0,
  triggerRefresh: () => set(state => ({ refreshCounter: state.refreshCounter + 1 })),

  // Transport-Status (ersetzt CustomEvent 'transport-complete')
  lastTransportEvent: null,
  setTransportEvent: (event) => set({ lastTransportEvent: { ...event, timestamp: Date.now() } }),

  // Deploy-Status (ersetzt CustomEvent 'deploy-status')
  deployStatus: {},  // "instanceId:flowId" → { status, timestamp }
  setDeployStatus: (instanceId, flowId, status) => set(state => ({
    deployStatus: { ...state.deployStatus, [`${instanceId}:${flowId}`]: { status, timestamp: Date.now() } }
  })),

  // Navigation Event (ersetzt CustomEvent 'cpi-nav-pd')
  lastNavPdEvent: null,
  setNavPdEvent: (detail) => set({ lastNavPdEvent: { ...detail, timestamp: Date.now() } }),

  // Experimentelles Caching Flag (geladen aus Settings)
  experimentalCaching: false,
  setExperimentalCaching: (enabled) => set({ experimentalCaching: enabled }),

  // Aktiver iFlow-Kontext für den AI-Chat (Multi-Agent-Pipeline)
  // STRIKTE INSTANZ-TRENNUNG: ChatPanel sendet Tools nur für GENAU diese Instanz/Flow.
  currentFlowContext: null, // null | { instanceId, instanceName, flowId, flowName, focusStep? }
  setCurrentFlowContext: (ctx) => {
    if (!ctx || !ctx.instanceId || !ctx.flowId) {
      set({ currentFlowContext: null });
      return;
    }
    set({ currentFlowContext: { ...ctx } });
  },
  clearCurrentFlowContext: () => set({ currentFlowContext: null }),
}));

export default useDashboardStore;
